import { useObserver } from 'mobx-react-lite'
import { FC, ReactElement, useState } from 'react'

import { DocumentInterface } from '../Documents'
import { ProgressEventHandler } from './DocumentsUpload'
import { DocumentsUploadDialogProps } from './DocumentsUploadDialog'

export interface IUploadButtonProps {
  onClickHandler: () => void
}

interface IDocumentUploadButtonProps {
  upload: (
    file,
    onProgress: ProgressEventHandler,
    type: string,
    options?: Record<string, string | string[]>
  ) => Promise<DocumentInterface>
  renderUploadButton: (prop: IUploadButtonProps) => ReactElement
  renderUploadDialog: (prop: Omit<DocumentsUploadDialogProps, 'type'>) => ReactElement
  documentRole?: string
  isTriangularShipment?: boolean
  onSuccess?: () => void
  handleError?: (e: string) => void
}

export const DocumentUploadButton: FC<IDocumentUploadButtonProps> = ({
  documentRole,
  isTriangularShipment,
  handleError: handleErrorProp,
  onSuccess: onSuccessProp,
  upload: uploadProp,
  renderUploadButton,
  renderUploadDialog,
}) => {
  const [open, setIsOpen] = useState(false)

  const handleError = (e) => {
    setIsOpen(false)
    handleErrorProp?.(e)
  }

  const upload = async (
    file,
    onProgress: ProgressEventHandler,
    type: string,
    options?: Record<string, string | string[]>
  ): Promise<DocumentInterface> => {
    const upload = await uploadProp(file, onProgress, type, options)

    setIsOpen(false)
    onSuccessProp?.()
    return upload
  }

  return useObserver(() => (
    <div>
      {renderUploadButton({ onClickHandler: () => setIsOpen(true) })}
      {renderUploadDialog({
        open,
        upload,
        closeDialog: () => setIsOpen(false),
        handleError,
        defaultValue: documentRole,
        isTriangularShipment,
      })}
    </div>
  ))
}
